import type * as DialogPrimitive from "@radix-ui/react-dialog";
import type * as React from "react";

// Size configuration
export const dialogSizes = {
  xs: "sm:max-w-xs", // ~320px - Small confirmations
  sm: "sm:max-w-md", // ~448px - Standard confirmations
  md: "sm:max-w-lg", // ~512px - Default, simple forms (2-3 fields)
  lg: "sm:max-w-xl", // ~576px - Medium forms (4-6 fields)
  xl: "sm:max-w-2xl", // ~672px - Large forms, complex content
  "2xl": "sm:max-w-3xl", // ~768px - AI dialogs, rich content
  "3xl": "sm:max-w-4xl", // ~896px - Wide content
  full: "sm:max-w-[90vw]", // Almost full screen
} as const;

export type DialogSize = keyof typeof dialogSizes;

export const footerLayouts = {
  default: "grid grid-cols-2 gap-2 sm:flex sm:justify-end",
  "space-between": "flex justify-between",
  start: "flex justify-start gap-2",
  end: "flex justify-end gap-2",
  center: "flex justify-center gap-2",
} as const;

export type FooterLayout = keyof typeof footerLayouts;

// Component prop types
export type DialogProps = React.ComponentProps<typeof DialogPrimitive.Root>;

export type DialogTriggerProps = React.ComponentProps<
  typeof DialogPrimitive.Trigger
>;

export type DialogPortalProps = React.ComponentProps<
  typeof DialogPrimitive.Portal
>;

export type DialogCloseProps = React.ComponentProps<
  typeof DialogPrimitive.Close
>;

export type DialogOverlayProps = React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Overlay
> & {
  showOverlay?: boolean;
};

export type DialogContentProps = React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Content
> & {
  size?: DialogSize;
  showCloseButton?: boolean;
  showOverlay?: boolean;
};

export type DialogHeaderProps = React.HTMLAttributes<HTMLDivElement>;

export type DialogFooterProps = React.HTMLAttributes<HTMLDivElement> & {
  layout?: FooterLayout;
};

export type DialogTitleProps = React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Title
>;

export type DialogDescriptionProps = React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Description
>;
